import { createReducer, on } from '@ngrx/store';
import * as TotalGrossActions from './total-gross.actions';
import { TotalGross, TotalGrossValidation } from './total-gross.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface TotalGrossState {
    totalGrosses: TotalGross[];
    totalGross: TotalGross | null;
    totalGrossValidation: TotalGrossValidation;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialTotalGrossState: TotalGrossState = {
    totalGrosses: [],
    totalGross: null,
    totalGrossValidation: {
        locationsWithGrossMismatch: [],
        locationsWithoutTotalGross: [],
    },
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Total Grosses Reducer
export const TotalGrossReducer = createReducer(
    initialTotalGrossState,

    // On Update
    on(TotalGrossActions.updateTotalGross, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TotalGrossActions.updateTotalGrossSuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
    })),
    on(TotalGrossActions.updateTotalGrossFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Validate
    on(TotalGrossActions.validateTotalGross, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(TotalGrossActions.validateTotalGrossSuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
        totalGrossValidation: data,
    })),
    on(TotalGrossActions.validateTotalGrossFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Clear
    on(TotalGrossActions.clearTotalGrossValidation, (state) => ({
        ...state,
        totalGrossValidation: {
            locationsWithGrossMismatch: [],
            locationsWithoutTotalGross: [],
        },
    }))
);
